import { SVGProps, Ref, forwardRef } from 'react';

export const MicOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.8 6c0-1.442.46-2.144.915-2.523.512-.428 1.302-.677 2.285-.677.982 0 1.772.25 2.285.677.455.379.915 1.08.915 2.523v5c0 1.442-.46 2.144-.915 2.523-.513.428-1.303.677-2.285.677s-1.773-.25-2.285-.677C9.259 13.144 8.8 12.443 8.8 11zM7 11V6c0-3.75 2.5-5 5-5s5 1.25 5 5v5c0 3.75-2.5 5-5 5s-5-1.25-5-5m-3.92 1c.578 5.183 4.189 7.204 8.02 7.47v1.73H6.945V23h10v-1.8H12.9v-1.73c3.83-.266 7.442-2.287 8.02-7.47h-1.813c-.268 2.044-1.088 3.329-2.072 4.148C15.772 17.201 13.982 17.7 12 17.7s-3.772-.5-5.035-1.552C5.98 15.328 5.16 14.044 4.893 12z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MicOutlinedSize24Glyph.displayName = 'MicOutlinedSize24Glyph';
